import React from 'react'
import styles from './RequestItem.module.css'
import moment from 'moment'

function RequestItem({name,city,state,type,subType,message,contact,email,updatedDate}) {
    return (
        <div className={styles.component}>
            <div className={styles.details}>
                <span className={styles.name}>{name}</span><br/>
                <span className={styles.city}>Contact: {contact}</span><br/>
                <span className={styles.city}>{email}</span><br/>
                <span className={styles.city}>{city}, {state}</span><br/>

                <h1 className={styles.sideHead}> Resource Needed: <span className={styles.highlight}>{type}</span></h1>
                
                {(type === 'food' | type === 'plasma') ? (<span><h1 className={styles.sideHead}> Sub type: <span className={styles.highlight}>{subType}</span></h1><br/></span>) : null}
                <div className={styles.divider}/>

               


                <span><span className={styles.message}>"{message}"</span></span><br/><br/><br/>
 
                <span className={styles.date}>{moment(updatedDate).calendar()}</span>
            </div>
        </div>
    )
}

export default RequestItem
